// extracted by mini-css-extract-plugin
export default {"fluidWidth":"fluidWidth__H0Oke","container":"container__2_or4"};